import { Box, type BoxProps } from '@mui/material';

export default function JourneyRideWordmark({ sx, ...props }: BoxProps) {
  return (
    <Box
      aria-label="ride"
      component="span"
      data-app-id="journey-ride-wordmark"
      role="img"
      sx={{
        display: 'inline-flex',
        flexShrink: 0,
        height: { sm: 36, xs: 28 },
        lineHeight: 0,
        maxWidth: { md: 137, sm: 120, xs: 100 },
        ...sx
      }}
      {...props}
    >
      <svg
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 137 40"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block', height: '100%', width: 'auto' }}
      >
        <path d="M23.5254 0.199463H15.4596L29.5748 39.8001H36.9685L23.5254 0.199463Z" fill="#9537FC" />
        <path d="M15.4596 18.5855L12.0988 9.39246L0 39.8001H7.39371L15.4596 18.5855Z" fill="#9537FC" />
        <path
          d="M126.076 39.9993C116.901 39.9993 112.314 37.051 112.314 31.1543V21.3515C112.314 17.9336 113.349 15.4547 115.42 13.9148C117.526 12.3749 120.757 11.605 125.112 11.605C129.218 11.605 132.216 12.3562 134.108 13.8585C136.036 15.3233 137 17.8209 137 21.3515V27.9993H120.186V30.4782C120.186 32.0557 120.721 33.1824 121.792 33.8585C122.863 34.5346 124.791 34.8726 127.575 34.8726C130.146 34.8726 133.037 34.4782 136.25 33.6895V38.9289C133.073 39.6425 129.682 39.9993 126.076 39.9993ZM129.557 23.3233V19.3796C129.557 18.4782 129.2 17.8022 128.486 17.3515C127.807 16.9008 126.647 16.6754 125.005 16.6754C123.113 16.6754 121.846 16.9008 121.203 17.3515C120.525 17.8397 120.186 18.5158 120.186 19.3796V23.3233H129.557Z"
          fill="white"
        />
        <path
          d="M90.4399 40C87.3697 40 85.1028 39.7746 83.6391 39.3239C82.1754 38.8357 81.158 37.9343 80.5868 36.6197C80.0156 35.3052 79.73 33.2582 79.73 30.4789V19.831C79.73 16.8263 80.5332 14.7042 82.1397 13.4648C83.7819 12.2254 86.4237 11.6056 90.0651 11.6056C91.7787 11.6056 93.1174 11.7183 94.0813 11.9437C95.0809 12.1315 95.8841 12.4883 96.491 13.0141C97.0979 13.5023 97.7227 14.2347 98.3653 15.2113V0H106.184V39.4366H98.633V36.338C97.9904 37.4272 97.4014 38.1972 96.8659 38.6479C96.3661 39.061 95.6521 39.3803 94.7239 39.6056C93.76 39.8685 92.332 40 90.4399 40ZM92.4212 34.8732C94.1705 34.8732 95.4557 34.7793 96.2768 34.5915C97.0979 34.4038 97.6513 34.0657 97.9369 33.5775C98.2225 33.0516 98.3653 32.2817 98.3653 31.2676V20.2817C98.3653 19.3427 98.2046 18.6291 97.8833 18.1408C97.5977 17.615 97.0622 17.2394 96.2768 17.0141C95.5271 16.7887 94.3847 16.6761 92.8496 16.6761C91.2074 16.6761 90.0294 16.7887 89.3154 17.0141C88.6014 17.2019 88.1194 17.5587 87.8695 18.0845C87.6553 18.5728 87.5482 19.3991 87.5482 20.5634V30.9859C87.5482 32.0376 87.6553 32.8451 87.8695 33.4085C88.1194 33.9343 88.5835 34.3099 89.2618 34.5352C89.9401 34.7606 90.9933 34.8732 92.4212 34.8732Z"
          fill="white"
        />
        <path
          d="M65.5818 2.30981H73.4V8.9577H65.5818V2.30981ZM65.5818 12.169H73.4V39.4366H65.5818V12.169Z"
          fill="white"
        />
        <path
          d="M44.0857 12.1688H51.5291V16.9576C51.5291 16.0937 51.8683 15.2487 52.5466 14.4224C53.2248 13.5961 54.0816 12.92 55.1169 12.3942C56.1879 11.8684 57.2411 11.6055 58.2764 11.6055H61.0609V18.4224H58.3835C56.1701 18.4224 54.5279 18.7792 53.4569 19.4928C52.4216 20.2064 51.904 21.3895 51.904 23.0421V39.4365H44.0857V12.1688Z"
          fill="white"
        />
      </svg>
    </Box>
  );
}
